import React, { FC, ReactNode } from "react";

import { Box, Typography } from "@components/base";

interface HighlightText {
  isHighlighted: boolean;
  children: ReactNode;
}
export const HighlightText: FC<HighlightText> = ({ isHighlighted, children }) => (
  <Typography>
    <Box
      component="span"
      sx={{
        background: isHighlighted ? "#FFE2BB" : undefined,
      }}
    >
      {children}
    </Box>
  </Typography>
);
